var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar-with-sidebar-layout"}},[_c('Navbar'),_c('Sidebar'),_c('v-main',{style:(_vm.$store.getters.isSidebarExpanded ? 'margin-left: 56px' : 'margin-left: 0px')},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }